import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DateInput from "./DateInput";
import ClientInput from "./ClientInput";
import StoreInput from "./StoreInput";
import NoteInput from "./NoteInput";

const BasicInformation = ({
   control,
   errors,
   register,
   setValue,
   setValues,
   setProducts,
   setLoadModal,
   setModalValidationMsg,
}) => {
   const { t: translator } = useTranslation();

   const [stores, setStores] = useState([]);

   return (
      <div className="col-lg-4">
         <fieldset className="scheduler-border">
            <legend className="scheduler-border">
               {translator("InitialState-IndexData")}
            </legend>
            <div className="form-group">
               <DateInput control={control} errors={errors} />
               <ClientInput
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  setValues={setValues}
                  setStores={setStores}
                  setProducts={setProducts}
               />
               <StoreInput
                  stores={stores}
                  errors={errors}
                  control={control}
                  setProducts={setProducts}
                  setValues={setValues}
                  setLoadModal={setLoadModal}
                  setModalValidationMsg={setModalValidationMsg}
               />
               <NoteInput errors={errors} register={register} />
            </div>
         </fieldset>
      </div>
   );
};

export default BasicInformation;
